export default {
  en: {
    answered: 'Answered',
    abandoned: 'Abandoned',
    transferred: 'Transferred',
  },
  es: {
    answered: 'Contestadas',
    abandoned: 'Abandonadas',
    transferred: 'Transferidas',
  },
};
